import * as React from "react";
const SvgUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.625 9.1875L7 4.8125L11.375 9.1875", stroke: "#919191", style: {
  stroke: "#919191",
  stroke: "color(display-p3 0.5686 0.5686 0.5686)",
  strokeOpacity: 1
}, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgUp;
